import { render, staticRenderFns } from "./egresosCaja.vue?vue&type=template&id=6d72684e&"
import script from "./egresosCaja.vue?vue&type=script&lang=js&"
export * from "./egresosCaja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports